import * as a from "react";
const e = (l) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M17.932 16.326a.187.187 0 00.15-.067.217.217 0 00.038-.15 9.586 9.586 0 00-.555-1.92.18.18 0 01.067-.226l.75-.517a.75.75 0 00-.825-1.252l-.63.42a.195.195 0 01-.262-.053 8.651 8.651 0 00-.585-.795.18.18 0 010-.24l.69-.84a.75.75 0 00-.105-1.057.75.75 0 00-1.05.105l-.578.697a.196.196 0 01-.127.068.225.225 0 01-.135-.045 8.346 8.346 0 00-.885-.645.188.188 0 01-.06-.248l.322-.547a.75.75 0 00-.292-1.02.75.75 0 00-1.02.27l-.315.585a.195.195 0 01-.233.082 9.26 9.26 0 00-1.642-.502.187.187 0 01-.15-.165V4.139a1.125 1.125 0 00-1.125-1.125h-3.75A1.125 1.125 0 004.5 4.139v12a.188.188 0 00.188.187h13.244zM18.39 17.451H4.687a.188.188 0 00-.187.188v2.295a1.102 1.102 0 001.125 1.08h12.75a1.104 1.104 0 001.125-1.08V18.53a1.102 1.102 0 00-1.11-1.08z",
      fill: "#333"
    }
  )
), t = e;
export {
  t as default
};
